/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Positions
 * OpenAPI спецификация для управления вакансиями (positions). Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AiScreeningToggleRequest
 */
export interface AiScreeningToggleRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AiScreeningToggleRequest
     */
    'aiScreeningEnabled': boolean;
}
/**
 * 
 * @export
 * @interface AiScreeningToggleResponse
 */
export interface AiScreeningToggleResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AiScreeningToggleResponse
     */
    'aiScreeningEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface BaseQuestionFields
 */
export interface BaseQuestionFields {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof BaseQuestionFields
     */
    'text'?: string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof BaseQuestionFields
     */
    'order'?: number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof BaseQuestionFields
     */
    'isRequired'?: boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof BaseQuestionFields
     */
    'evaluationCriteria'?: string;
}
/**
 * 
 * @export
 * @interface BulkVoiceSynthesisRequest
 */
export interface BulkVoiceSynthesisRequest {
    /**
     * ID голоса для озвучки
     * @type {string}
     * @memberof BulkVoiceSynthesisRequest
     */
    'voiceId'?: string;
    /**
     * Модель TTS
     * @type {string}
     * @memberof BulkVoiceSynthesisRequest
     */
    'model'?: string;
    /**
     * Формат аудио
     * @type {string}
     * @memberof BulkVoiceSynthesisRequest
     */
    'format'?: BulkVoiceSynthesisRequestFormat;
    /**
     * Принудительная переозвучка всех вопросов
     * @type {boolean}
     * @memberof BulkVoiceSynthesisRequest
     */
    'forceRegenerate'?: boolean;
}

export const BulkVoiceSynthesisRequestFormat = {
    MP3: 'mp3',
    WAV: 'wav',
    M4A: 'm4a'
} as const;

export type BulkVoiceSynthesisRequestFormat = typeof BulkVoiceSynthesisRequestFormat[keyof typeof BulkVoiceSynthesisRequestFormat];

/**
 * 
 * @export
 * @interface BulkVoiceSynthesisResponse
 */
export interface BulkVoiceSynthesisResponse {
    /**
     * ID позиции
     * @type {number}
     * @memberof BulkVoiceSynthesisResponse
     */
    'positionId': number;
    /**
     * Задача принята
     * @type {boolean}
     * @memberof BulkVoiceSynthesisResponse
     */
    'accepted': boolean;
    /**
     * Общее количество вопросов
     * @type {number}
     * @memberof BulkVoiceSynthesisResponse
     */
    'total': number;
    /**
     * ID задачи для отслеживания прогресса
     * @type {string}
     * @memberof BulkVoiceSynthesisResponse
     */
    'taskId': string;
    /**
     * Ориентировочная длительность в секундах
     * @type {number}
     * @memberof BulkVoiceSynthesisResponse
     */
    'estimatedDuration'?: number;
}
/**
 * 
 * @export
 * @interface CompanyQuestion
 */
export interface CompanyQuestion {
    /**
     * 
     * @type {number}
     * @memberof CompanyQuestion
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestion
     */
    'question': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestion
     */
    'answer'?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyQuestion
     */
    'orderIndex': number;
}
/**
 * 
 * @export
 * @interface CompanyQuestions
 */
export interface CompanyQuestions {
    /**
     * 
     * @type {number}
     * @memberof CompanyQuestions
     */
    'id'?: number;
    /**
     * 
     * @type {Array<CompanyQuestion>}
     * @memberof CompanyQuestions
     */
    'questions': Array<CompanyQuestion>;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestions
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyQuestions
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface CompanyQuestionsRequest
 */
export interface CompanyQuestionsRequest {
    /**
     * 
     * @type {Array<CompanyQuestion>}
     * @memberof CompanyQuestionsRequest
     */
    'questions': Array<CompanyQuestion>;
}
/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * Настройки проведения интервью для вакансии. Все поля являются опциональными - обновляются только переданные значения. 
 * @export
 * @interface InterviewSettingsUpdate
 */
export interface InterviewSettingsUpdate {
    /**
     * Нужная оценка для получения успешного интервью 
     * @type {number}
     * @memberof InterviewSettingsUpdate
     */
    'minScore'?: number;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof InterviewSettingsUpdate
     */
    'level'?: PositionLevelEnum;
    /**
     * Разделы PDF-отчёта AI-скрининга (JUSTIFICATION, CRITERIA_DETAILS, STRENGTHS, RECOMMENDATIONS, TRANSCRIPT). Пустой список — ни одного раздела. 
     * @type {Array<string>}
     * @memberof InterviewSettingsUpdate
     */
    'pdfReportSections'?: Array<string>;
    /**
     * Время ответа на вопрос в секундах. Минимальное значение: 30, максимальное: 600. 
     * @type {number}
     * @memberof InterviewSettingsUpdate
     */
    'answerTime'?: number;
    /**
     * Язык проведения интервью. Поддерживаемые значения: ru, en. 
     * @type {string}
     * @memberof InterviewSettingsUpdate
     */
    'language'?: string;
    /**
     * Показывать вопросы на других языках помимо основного. Полезно для международных компаний. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'showOtherLang'?: boolean;
    /**
     * Случайный порядок вопросов при проведении интервью. Помогает избежать списывания и стандартизации ответов. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'randomOrder'?: boolean;
    /**
     * Сохранять аудио ответы кандидатов. Требует дополнительного места на диске. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'saveAudio'?: boolean;
    /**
     * Сохранять видео ответы кандидатов. Требует значительного места на диске. 
     * @type {boolean}
     * @memberof InterviewSettingsUpdate
     */
    'saveVideo'?: boolean;
}


/**
 * Пара станция метро + адрес офиса (оба поля nullable)
 * @export
 * @interface OfficeLocation
 */
export interface OfficeLocation {
    /**
     * ID станции метро из справочника HH (формат \"lineId.stationId\", напр. \"14.192\")
     * @type {string}
     * @memberof OfficeLocation
     */
    'metroStationId'?: string | null;
    /**
     * Адрес офиса
     * @type {string}
     * @memberof OfficeLocation
     */
    'address'?: string | null;
    /**
     * ID адреса работодателя HH из /employers/{employer_id}/addresses
     * @type {string}
     * @memberof OfficeLocation
     */
    'hhAddressId'?: string | null;
}
/**
 * Базовый класс для всех пагинированных ответов
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Список элементов на текущей странице
     * @type {Array<object>}
     * @memberof PaginatedResponse
     */
    'content': Array<object>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof PaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof PaginatedResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'description'?: string;
    /**
     * 
     * @type {PositionStatusEnum}
     * @memberof Position
     */
    'status': PositionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'publicLink'?: string;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'minScore'?: number;
    /**
     * Средний балл по всем завершенным интервью для данной вакансии
     * @type {number}
     * @memberof Position
     */
    'averageScore'?: number;
    /**
     * Количество интервью, связанных с вакансией
     * @type {number}
     * @memberof Position
     */
    'interviewsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'createdBy': number;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'managerId'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Position
     */
    'topics'?: Array<string>;
    /**
     * Группы навыков в формате JSON
     * @type {string}
     * @memberof Position
     */
    'skillGroups'?: string;
    /**
     * Внутренняя метка (видна только вам)
     * @type {string}
     * @memberof Position
     */
    'internalTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof Position
     */
    'language'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Position
     */
    'showOtherLang'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'answerTime'?: number;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof Position
     */
    'level'?: PositionLevelEnum;
    /**
     * Требовать подтверждение email кандидата перед началом интервью
     * @type {boolean}
     * @memberof Position
     */
    'emailVerificationRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Position
     */
    'questionsCount'?: number;
    /**
     * Отрасль
     * @type {string}
     * @memberof Position
     */
    'industry'?: string;
    /**
     * Специализация HH
     * @type {string}
     * @memberof Position
     */
    'specialization'?: string;
    /**
     * Специализация Авито
     * @type {string}
     * @memberof Position
     */
    'avitoSpecialization'?: string;
    /**
     * Список городов HH
     * @type {Array<string>}
     * @memberof Position
     */
    'cities'?: Array<string>;
    /**
     * Список локаций Авито
     * @type {Array<string>}
     * @memberof Position
     */
    'avitoLocationIds'?: Array<string>;
    /**
     * Статусы поиска кандидата
     * @type {Array<string>}
     * @memberof Position
     */
    'candidateStatuses'?: Array<string>;
    /**
     * Опыт в должности
     * @type {string}
     * @memberof Position
     */
    'experienceInPosition'?: string;
    /**
     * Период опыта
     * @type {string}
     * @memberof Position
     */
    'experiencePeriod'?: string;
    /**
     * Общий опыт
     * @type {string}
     * @memberof Position
     */
    'totalExperience'?: string;
    /**
     * Зарплата от
     * @type {number}
     * @memberof Position
     */
    'salaryFrom'?: number;
    /**
     * Зарплата до
     * @type {number}
     * @memberof Position
     */
    'salaryTo'?: number;
    /**
     * Образование
     * @type {string}
     * @memberof Position
     */
    'education'?: string;
    /**
     * Возраст от
     * @type {number}
     * @memberof Position
     */
    'ageFrom'?: number;
    /**
     * Возраст до
     * @type {number}
     * @memberof Position
     */
    'ageTo'?: number;
    /**
     * Включая без возраста
     * @type {boolean}
     * @memberof Position
     */
    'includeNoAge'?: boolean;
    /**
     * Пол (any, male, female)
     * @type {string}
     * @memberof Position
     */
    'gender'?: string;
    /**
     * Гражданство
     * @type {Array<string>}
     * @memberof Position
     */
    'citizenship'?: Array<string>;
    /**
     * Типы занятости
     * @type {Array<string>}
     * @memberof Position
     */
    'employmentTypes'?: Array<string>;
    /**
     * Описание компании и команды (Rich text)
     * @type {string}
     * @memberof Position
     */
    'companyDescription'?: string;
    /**
     * Формат работы (Офис/Гибрид/Удаленка)
     * @type {string}
     * @memberof Position
     */
    'workFormat'?: string;
    /**
     * График работы
     * @type {string}
     * @memberof Position
     */
    'workSchedule'?: string;
    /**
     * Город офиса (id из справочника HH metro)
     * @type {string}
     * @memberof Position
     */
    'officeCityId'?: string;
    /**
     * Расположения офисов (станция метро + адрес)
     * @type {Array<OfficeLocation>}
     * @memberof Position
     */
    'officeLocations'?: Array<OfficeLocation>;
    /**
     * Учитывать станции метро при поиске кандидатов
     * @type {boolean}
     * @memberof Position
     */
    'useMetroInSearch'?: boolean;
    /**
     * Типы оформления
     * @type {Array<string>}
     * @memberof Position
     */
    'employmentContractTypes'?: Array<string>;
    /**
     * Что входит в соц.пакет (текстовый формат, автозаполняется из branding.benefits)
     * @type {string}
     * @memberof Position
     */
    'socialPackageText'?: string;
    /**
     * Страна или город релокации
     * @type {string}
     * @memberof Position
     */
    'relocationLocation'?: string;
    /**
     * Помощь при релокации
     * @type {string}
     * @memberof Position
     */
    'relocationAssistance'?: string;
    /**
     * NDA
     * @type {boolean}
     * @memberof Position
     */
    'hasNda'?: boolean;
    /**
     * Премии
     * @type {boolean}
     * @memberof Position
     */
    'hasBonuses'?: boolean;
    /**
     * Указана ЗП
     * @type {boolean}
     * @memberof Position
     */
    'salarySpecified'?: boolean;
    /**
     * ЗП до вычета налогов (true) или на руки (false)
     * @type {boolean}
     * @memberof Position
     */
    'salaryGross'?: boolean;
    /**
     * Частота выплаты зарплаты (ID из справочника HH salary_range_frequency)
     * @type {string}
     * @memberof Position
     */
    'salaryFrequency'?: string;
    /**
     * Валюта зарплаты (код из справочника HH, например RUR, USD, EUR, KZT)
     * @type {string}
     * @memberof Position
     */
    'salaryCurrency'?: string | null;
    /**
     * Рабочие часы в сутки (ID из справочника HH working_hours)
     * @type {string}
     * @memberof Position
     */
    'workingHours'?: string;
    /**
     * Включен ли AI-скрининг для вакансии
     * @type {boolean}
     * @memberof Position
     */
    'aiScreeningEnabled'?: boolean;
    /**
     * Включено ли HR-интервью для вакансии. Если false и aiScreeningEnabled=false, кандидаты автоматически одобряются.
     * @type {boolean}
     * @memberof Position
     */
    'hrInterviewEnabled'?: boolean;
    /**
     * JSON с требованиями к кандидату с весами для скоринга и диалогов
     * @type {string}
     * @memberof Position
     */
    'aiRequirementsWeighted'?: string;
    /**
     * Разделы PDF-отчёта AI-скрининга, которые попадают в файл (JUSTIFICATION, CRITERIA_DETAILS, STRENGTHS, RECOMMENDATIONS, TRANSCRIPT). Пустой список трактуется как «включены все».
     * @type {Array<string>}
     * @memberof Position
     */
    'pdfReportSections'?: Array<string>;
    /**
     * ID основной вакансии на HH.ru
     * @type {string}
     * @memberof Position
     */
    'hhVacancyId'?: string;
    /**
     * ID связанной вакансии на Авито
     * @type {string}
     * @memberof Position
     */
    'avitoVacancyId'?: string;
    /**
     * ID дополнительных вакансий на HH.ru
     * @type {Array<string>}
     * @memberof Position
     */
    'hhAdditionalVacancyIds'?: Array<string>;
    /**
     * UUID slug для публичных ссылок (защита от перебора Long ID)
     * @type {string}
     * @memberof Position
     */
    'publicSlug'?: string;
    /**
     * Строгий поиск по региону — только живущие в указанных городах (HH relocation=living)
     * @type {boolean}
     * @memberof Position
     */
    'strictRegionSearch'?: boolean;
}


/**
 * 
 * @export
 * @interface PositionCreateRequest
 */
export interface PositionCreateRequest {
    /**
     * Название внутренней вакансии (до 500 символов)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'title': string;
    /**
     * Описание вакансии
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'description': string;
    /**
     * 
     * @type {PositionStatusEnum}
     * @memberof PositionCreateRequest
     */
    'status': PositionStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'topics': Array<string>;
    /**
     * Группы навыков в формате JSON
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'skillGroups'?: string;
    /**
     * Внутренняя метка (видна только вам)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'internalTag'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'minScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'answerTime': number;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof PositionCreateRequest
     */
    'level': PositionLevelEnum;
    /**
     * Требовать подтверждение email кандидата перед началом интервью
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'emailVerificationRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'questionsCount': number;
    /**
     * Отрасль
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'industry'?: string;
    /**
     * Специализация HH
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'specialization'?: string;
    /**
     * Специализация Авито
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'avitoSpecialization'?: string;
    /**
     * Список городов HH
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'cities'?: Array<string>;
    /**
     * Список локаций Авито
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'avitoLocationIds'?: Array<string>;
    /**
     * Статусы поиска кандидата
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'candidateStatuses'?: Array<string>;
    /**
     * Опыт в должности
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'experienceInPosition'?: string;
    /**
     * Период опыта
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'experiencePeriod'?: string;
    /**
     * Общий опыт
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'totalExperience'?: string;
    /**
     * Зарплата от
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'salaryFrom'?: number;
    /**
     * Зарплата до
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'salaryTo'?: number;
    /**
     * Образование
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'education'?: string;
    /**
     * Возраст от
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'ageFrom'?: number;
    /**
     * Возраст до
     * @type {number}
     * @memberof PositionCreateRequest
     */
    'ageTo'?: number;
    /**
     * Включая без возраста
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'includeNoAge'?: boolean;
    /**
     * Пол (any, male, female)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'gender'?: string;
    /**
     * Гражданство
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'citizenship'?: Array<string>;
    /**
     * Типы занятости
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'employmentTypes'?: Array<string>;
    /**
     * Описание компании и команды (Rich text)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'companyDescription'?: string;
    /**
     * Формат работы (Офис/Гибрид/Удаленка)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'workFormat'?: string;
    /**
     * График работы
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'workSchedule'?: string;
    /**
     * Город офиса (id из справочника HH metro)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'officeCityId'?: string;
    /**
     * Расположения офисов (станция метро + адрес)
     * @type {Array<OfficeLocation>}
     * @memberof PositionCreateRequest
     */
    'officeLocations'?: Array<OfficeLocation>;
    /**
     * Учитывать станции метро при поиске кандидатов
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'useMetroInSearch'?: boolean;
    /**
     * Типы оформления
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'employmentContractTypes'?: Array<string>;
    /**
     * Что входит в соц.пакет (текстовый формат, автозаполняется из branding.benefits)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'socialPackageText'?: string;
    /**
     * Страна или город релокации
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'relocationLocation'?: string;
    /**
     * Помощь при релокации
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'relocationAssistance'?: string;
    /**
     * NDA
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'hasNda'?: boolean;
    /**
     * Премии
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'hasBonuses'?: boolean;
    /**
     * Указана ЗП
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'salarySpecified'?: boolean;
    /**
     * ЗП до вычета налогов (true) или на руки (false)
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'salaryGross'?: boolean;
    /**
     * Частота выплаты зарплаты (ID из справочника HH salary_range_frequency)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'salaryFrequency'?: string;
    /**
     * Валюта зарплаты (код из справочника HH, например RUR, USD, EUR, KZT)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'salaryCurrency'?: string | null;
    /**
     * Рабочие часы в сутки (ID из справочника HH working_hours)
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'workingHours'?: string;
    /**
     * Включен ли AI-скрининг для вакансии
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'aiScreeningEnabled'?: boolean;
    /**
     * Включено ли HR-интервью для вакансии. Если false и aiScreeningEnabled=false, кандидаты автоматически одобряются.
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'hrInterviewEnabled'?: boolean;
    /**
     * JSON с требованиями к кандидату с весами
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'aiRequirementsWeighted'?: string;
    /**
     * Разделы PDF-отчёта AI-скрининга (JUSTIFICATION, CRITERIA_DETAILS, STRENGTHS, RECOMMENDATIONS, TRANSCRIPT). Пустой список = включены все.
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'pdfReportSections'?: Array<string>;
    /**
     * ID основной вакансии на HH.ru
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'hhVacancyId'?: string;
    /**
     * ID связанной вакансии на Авито
     * @type {string}
     * @memberof PositionCreateRequest
     */
    'avitoVacancyId'?: string;
    /**
     * ID дополнительных вакансий на HH.ru
     * @type {Array<string>}
     * @memberof PositionCreateRequest
     */
    'hhAdditionalVacancyIds'?: Array<string>;
    /**
     * Строгий поиск по региону — только живущие в указанных городах (HH relocation=living)
     * @type {boolean}
     * @memberof PositionCreateRequest
     */
    'strictRegionSearch'?: boolean;
}


/**
 * Уровень вакансии
 * @export
 * @enum {string}
 */

export const PositionLevelEnum = {
    JUNIOR: 'JUNIOR',
    MIDDLE: 'MIDDLE',
    SENIOR: 'SENIOR',
    LEAD: 'LEAD'
} as const;

export type PositionLevelEnum = typeof PositionLevelEnum[keyof typeof PositionLevelEnum];


/**
 * Публичные данные вакансии (без авторизации)
 * @export
 * @interface PositionPublicResponse
 */
export interface PositionPublicResponse {
    /**
     * 
     * @type {number}
     * @memberof PositionPublicResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'publicSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'companyDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'workFormat'?: string;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'workSchedule'?: string;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof PositionPublicResponse
     */
    'level'?: PositionLevelEnum;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'skillGroups'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionPublicResponse
     */
    'salaryFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionPublicResponse
     */
    'salaryTo'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PositionPublicResponse
     */
    'salarySpecified'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PositionPublicResponse
     */
    'salaryGross'?: boolean;
    /**
     * Частота выплаты зарплаты (ID из справочника HH salary_range_frequency)
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'salaryFrequency'?: string;
    /**
     * Валюта зарплаты (код из справочника HH, например RUR, USD, EUR, KZT)
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'salaryCurrency'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'workingHours'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PositionPublicResponse
     */
    'hasNda'?: boolean;
    /**
     * 
     * @type {PositionStatusEnum}
     * @memberof PositionPublicResponse
     */
    'status'?: PositionStatusEnum;
    /**
     * Город офиса (id из справочника HH metro)
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'officeCityId'?: string | null;
    /**
     * Расположения офисов (станция метро + адрес)
     * @type {Array<OfficeLocation>}
     * @memberof PositionPublicResponse
     */
    'officeLocations'?: Array<OfficeLocation>;
    /**
     * Типы занятости
     * @type {Array<string>}
     * @memberof PositionPublicResponse
     */
    'employmentTypes'?: Array<string>;
    /**
     * Типы оформления
     * @type {Array<string>}
     * @memberof PositionPublicResponse
     */
    'employmentContractTypes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'companyName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionPublicResponse
     */
    'companyId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'primaryColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'secondaryColor'?: string | null;
    /**
     * Что входит в соц. пакет
     * @type {string}
     * @memberof PositionPublicResponse
     */
    'socialPackageText'?: string | null;
}


/**
 * Запрос на обновление настроек интервью и вопросов вакансии. Поддерживает как ручное обновление существующих вопросов, так и автоматическую генерацию новых через ИИ. 
 * @export
 * @interface PositionQuestionsAndSettingsUpdateRequest
 */
export interface PositionQuestionsAndSettingsUpdateRequest {
    /**
     * 
     * @type {InterviewSettingsUpdate}
     * @memberof PositionQuestionsAndSettingsUpdateRequest
     */
    'interviewSettings': InterviewSettingsUpdate;
    /**
     * Список вопросов для обновления. Если не указан и regenerateQuestions=true, то вопросы генерируются автоматически. 
     * @type {Array<QuestionUpdateRequest>}
     * @memberof PositionQuestionsAndSettingsUpdateRequest
     */
    'questions'?: Array<QuestionUpdateRequest> | null;
    /**
     * Перегенерировать все вопросы с новыми настройками через ИИ. При true игнорируется поле questions и генерируются новые вопросы с учетом ВСЕХ полей вакансии. 
     * @type {boolean}
     * @memberof PositionQuestionsAndSettingsUpdateRequest
     */
    'regenerateQuestions'?: boolean;
    /**
     * Дополнительный промпт для ИИ с конкретными требованиями к генерации вопросов (тематика, сложность, типы). 
     * @type {string}
     * @memberof PositionQuestionsAndSettingsUpdateRequest
     */
    'aiPrompt'?: string | null;
}
/**
 * Ответ с вопросами вакансии и настройками интервью
 * @export
 * @interface PositionQuestionsResponse
 */
export interface PositionQuestionsResponse {
    /**
     * Список вопросов вакансии
     * @type {Array<Question>}
     * @memberof PositionQuestionsResponse
     */
    'questions': Array<Question>;
    /**
     * 
     * @type {PositionQuestionsResponseInterviewSettings}
     * @memberof PositionQuestionsResponse
     */
    'interviewSettings'?: PositionQuestionsResponseInterviewSettings;
}
/**
 * Настройки проведения интервью для вакансии
 * @export
 * @interface PositionQuestionsResponseInterviewSettings
 */
export interface PositionQuestionsResponseInterviewSettings {
    /**
     * Время на ответ в секундах
     * @type {number}
     * @memberof PositionQuestionsResponseInterviewSettings
     */
    'answerTime'?: number;
    /**
     * Количество вопросов в вакансии
     * @type {number}
     * @memberof PositionQuestionsResponseInterviewSettings
     */
    'questionsCount'?: number;
    /**
     * Уровень сложности вакансии
     * @type {string}
     * @memberof PositionQuestionsResponseInterviewSettings
     */
    'level'?: string;
}
/**
 * 
 * @export
 * @interface PositionSkillsResponse
 */
export interface PositionSkillsResponse {
    /**
     * 
     * @type {number}
     * @memberof PositionSkillsResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PositionSkillsResponse
     */
    'skillGroups'?: string;
    /**
     * JSON-строка с взвешенными требованиями: {required:[{text,weight}], optional:[{text,weight}]}. Используется для ведения интервью агентом (сначала required, затем skills).
     * @type {string}
     * @memberof PositionSkillsResponse
     */
    'aiRequirementsWeighted'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PositionSkillsResponse
     */
    'description'?: string;
    /**
     * ID города офиса из справочника HH metro
     * @type {string}
     * @memberof PositionSkillsResponse
     */
    'officeCityId'?: string;
    /**
     * Расположения офисов (станция метро + адрес)
     * @type {Array<OfficeLocation>}
     * @memberof PositionSkillsResponse
     */
    'officeLocations'?: Array<OfficeLocation>;
}
/**
 * Статус вакансии
 * @export
 * @enum {string}
 */

export const PositionStatusEnum = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    ARCHIVED: 'ARCHIVED'
} as const;

export type PositionStatusEnum = typeof PositionStatusEnum[keyof typeof PositionStatusEnum];


/**
 * 
 * @export
 * @interface PositionUpdateRequest
 */
export interface PositionUpdateRequest {
    /**
     * Название внутренней вакансии (до 500 символов)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'title'?: string;
    /**
     * Описание вакансии
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {PositionStatusEnum}
     * @memberof PositionUpdateRequest
     */
    'status'?: PositionStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'topics'?: Array<string>;
    /**
     * Группы навыков в формате JSON
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'skillGroups'?: string;
    /**
     * Внутренняя метка (видна только вам)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'internalTag'?: string;
    /**
     * 
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'minScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'answerTime'?: number;
    /**
     * 
     * @type {PositionLevelEnum}
     * @memberof PositionUpdateRequest
     */
    'level'?: PositionLevelEnum;
    /**
     * Требовать подтверждение email кандидата перед началом интервью
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'emailVerificationRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'questionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'managerId'?: number | null;
    /**
     * Отрасль
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'industry'?: string;
    /**
     * Специализация HH
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'specialization'?: string;
    /**
     * Специализация Авито
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'avitoSpecialization'?: string;
    /**
     * Список городов HH
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'cities'?: Array<string>;
    /**
     * Список локаций Авито
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'avitoLocationIds'?: Array<string>;
    /**
     * Статусы поиска кандидата
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'candidateStatuses'?: Array<string>;
    /**
     * Опыт в должности
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'experienceInPosition'?: string;
    /**
     * Период опыта
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'experiencePeriod'?: string;
    /**
     * Общий опыт
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'totalExperience'?: string;
    /**
     * Зарплата от
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'salaryFrom'?: number;
    /**
     * Зарплата до
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'salaryTo'?: number;
    /**
     * Образование
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'education'?: string;
    /**
     * Возраст от
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'ageFrom'?: number;
    /**
     * Возраст до
     * @type {number}
     * @memberof PositionUpdateRequest
     */
    'ageTo'?: number;
    /**
     * Включая без возраста
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'includeNoAge'?: boolean;
    /**
     * Пол (any, male, female)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'gender'?: string;
    /**
     * Гражданство
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'citizenship'?: Array<string>;
    /**
     * Типы занятости
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'employmentTypes'?: Array<string>;
    /**
     * Описание компании и команды (Rich text)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'companyDescription'?: string;
    /**
     * Формат работы (Офис/Гибрид/Удаленка)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'workFormat'?: string;
    /**
     * График работы
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'workSchedule'?: string;
    /**
     * Город офиса (id из справочника HH metro)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'officeCityId'?: string;
    /**
     * Расположения офисов (станция метро + адрес)
     * @type {Array<OfficeLocation>}
     * @memberof PositionUpdateRequest
     */
    'officeLocations'?: Array<OfficeLocation>;
    /**
     * Учитывать станции метро при поиске кандидатов
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'useMetroInSearch'?: boolean;
    /**
     * Типы оформления
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'employmentContractTypes'?: Array<string>;
    /**
     * Что входит в соц.пакет (текстовый формат, автозаполняется из branding.benefits)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'socialPackageText'?: string;
    /**
     * Страна или город релокации
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'relocationLocation'?: string;
    /**
     * Помощь при релокации
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'relocationAssistance'?: string;
    /**
     * NDA
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'hasNda'?: boolean;
    /**
     * Премии
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'hasBonuses'?: boolean;
    /**
     * Указана ЗП
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'salarySpecified'?: boolean;
    /**
     * ЗП до вычета налогов (true) или на руки (false)
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'salaryGross'?: boolean;
    /**
     * Частота выплаты зарплаты (ID из справочника HH salary_range_frequency)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'salaryFrequency'?: string;
    /**
     * Валюта зарплаты (код из справочника HH, например RUR, USD, EUR, KZT)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'salaryCurrency'?: string | null;
    /**
     * Рабочие часы в сутки (ID из справочника HH working_hours)
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'workingHours'?: string;
    /**
     * Включен ли AI-скрининг для вакансии
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'aiScreeningEnabled'?: boolean;
    /**
     * Включено ли HR-интервью для вакансии. Если false и aiScreeningEnabled=false, кандидаты автоматически одобряются.
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'hrInterviewEnabled'?: boolean;
    /**
     * JSON с требованиями к кандидату с весами
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'aiRequirementsWeighted'?: string;
    /**
     * Разделы PDF-отчёта AI-скрининга (JUSTIFICATION, CRITERIA_DETAILS, STRENGTHS, RECOMMENDATIONS, TRANSCRIPT). Пустой список = включены все.
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'pdfReportSections'?: Array<string>;
    /**
     * ID основной вакансии на HH.ru
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'hhVacancyId'?: string | null;
    /**
     * ID связанной вакансии на Авито
     * @type {string}
     * @memberof PositionUpdateRequest
     */
    'avitoVacancyId'?: string | null;
    /**
     * ID дополнительных вакансий на HH.ru
     * @type {Array<string>}
     * @memberof PositionUpdateRequest
     */
    'hhAdditionalVacancyIds'?: Array<string>;
    /**
     * Строгий поиск по региону — только живущие в указанных городах (HH relocation=living)
     * @type {boolean}
     * @memberof PositionUpdateRequest
     */
    'strictRegionSearch'?: boolean;
}


/**
 * 
 * @export
 * @interface PositionVoiceStatusResponse
 */
export interface PositionVoiceStatusResponse {
    /**
     * ID позиции
     * @type {number}
     * @memberof PositionVoiceStatusResponse
     */
    'positionId': number;
    /**
     * Общее количество вопросов
     * @type {number}
     * @memberof PositionVoiceStatusResponse
     */
    'total': number;
    /**
     * Количество готовых вопросов
     * @type {number}
     * @memberof PositionVoiceStatusResponse
     */
    'ready': number;
    /**
     * Количество вопросов в процессе
     * @type {number}
     * @memberof PositionVoiceStatusResponse
     */
    'pending': number;
    /**
     * Количество вопросов с ошибками
     * @type {number}
     * @memberof PositionVoiceStatusResponse
     */
    'error': number;
    /**
     * Детальная информация по каждому вопросу
     * @type {Array<QuestionVoiceStatusResponse>}
     * @memberof PositionVoiceStatusResponse
     */
    'items': Array<QuestionVoiceStatusResponse>;
}
/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * ID вопроса
     * @type {number}
     * @memberof Question
     */
    'id': number;
    /**
     * ID вакансии
     * @type {number}
     * @memberof Question
     */
    'positionId': number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof Question
     */
    'text': string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof Question
     */
    'order': number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof Question
     */
    'isRequired': boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof Question
     */
    'evaluationCriteria'?: string;
    /**
     * Длительность аудиофайла в секундах
     * @type {number}
     * @memberof Question
     */
    'voiceDurationSec'?: number;
    /**
     * Время создания
     * @type {string}
     * @memberof Question
     */
    'createdAt': string;
    /**
     * Время последнего обновления
     * @type {string}
     * @memberof Question
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface QuestionUpdateRequest
 */
export interface QuestionUpdateRequest {
    /**
     * Текст вопроса
     * @type {string}
     * @memberof QuestionUpdateRequest
     */
    'text'?: string;
    /**
     * Порядок вопроса
     * @type {number}
     * @memberof QuestionUpdateRequest
     */
    'order'?: number;
    /**
     * Обязательный ли вопрос
     * @type {boolean}
     * @memberof QuestionUpdateRequest
     */
    'isRequired'?: boolean;
    /**
     * Критерии оценки ответа
     * @type {string}
     * @memberof QuestionUpdateRequest
     */
    'evaluationCriteria'?: string;
    /**
     * ID существующего вопроса для обновления. Отсутствует для нового вопроса
     * @type {number}
     * @memberof QuestionUpdateRequest
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface QuestionVoiceStatusResponse
 */
export interface QuestionVoiceStatusResponse {
    /**
     * ID вопроса
     * @type {number}
     * @memberof QuestionVoiceStatusResponse
     */
    'questionId': number;
    /**
     * Статус озвучки вопроса
     * @type {string}
     * @memberof QuestionVoiceStatusResponse
     */
    'status': QuestionVoiceStatusResponseStatus;
    /**
     * URL к аудиофайлу (если готов)
     * @type {string}
     * @memberof QuestionVoiceStatusResponse
     */
    'audioUrl'?: string | null;
    /**
     * Требуется ли переозвучка из-за изменений
     * @type {boolean}
     * @memberof QuestionVoiceStatusResponse
     */
    'hashMismatch': boolean;
    /**
     * Сообщение об ошибке (если есть)
     * @type {string}
     * @memberof QuestionVoiceStatusResponse
     */
    'errorMessage'?: string;
}

export const QuestionVoiceStatusResponseStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR'
} as const;

export type QuestionVoiceStatusResponseStatus = typeof QuestionVoiceStatusResponseStatus[keyof typeof QuestionVoiceStatusResponseStatus];


/**
 * PositionsApi - axios parameter creator
 * @export
 */
export const PositionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Назначает исполнителя (менеджера) для вакансии или снимает назначение. - Если указан managerId - назначает указанного пользователя менеджером - Если managerId не указан или равен null - снимает текущего менеджера Исполнитель должен быть из той же команды, что и вакансия. 
         * @summary Назначить или снять исполнителя (менеджера) вакансии
         * @param {number} id ID вакансии
         * @param {number | null} [managerId] ID пользователя-исполнителя (null или не указан для снятия назначения)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPositionManager: async (id: number, managerId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignPositionManager', 'id', id)
            const localVarPath = `/positions/{id}/manager`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (managerId !== undefined) {
                localVarQueryParameter['managerId'] = managerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Изменяет статус вакансии с дополнительной логикой и валидацией. Поддерживает переходы между статусами ACTIVE, PAUSED, ARCHIVED. При архивировании автоматически завершает все активные интервью. 
         * @summary Изменить статус вакансии
         * @param {number} id ID вакансии
         * @param {PositionStatusEnum} status Новый статус вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionStatus: async (id: number, status: PositionStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changePositionStatus', 'id', id)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('changePositionStatus', 'status', status)
            const localVarPath = `/positions/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создать вакансию в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать вакансию
         * @param {PositionCreateRequest} positionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPosition: async (positionCreateRequest: PositionCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'positionCreateRequest' is not null or undefined
            assertParamExists('createPosition', 'positionCreateRequest', positionCreateRequest)
            const localVarPath = `/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удалить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить вакансию
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePosition', 'id', id)
            const localVarPath = `/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить вакансию своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить вакансию по ID
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPosition', 'id', id)
            const localVarPath = `/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionAiScreeningFlag: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionAiScreeningFlag', 'id', id)
            const localVarPath = `/positions/{id}/ai-screening`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить вопросы о компании для вакансии
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionCompanyQuestions: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionCompanyQuestions', 'id', id)
            const localVarPath = `/positions/{id}/company-questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает только поля, необходимые для построения диалога рекрутера: skillGroups, description, officeCityId, officeLocations. Без данных брендинга (logoUrl, primaryColor, secondaryColor). Используется ai-recruiter-back (service-to-service). 
         * @summary Данные позиции для диалога (без брендинга)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionDialogueData: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionDialogueData', 'id', id)
            const localVarPath = `/public/positions/{id}/dialogue-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Доступно без авторизации (service-to-service). Используется ai-recruiter-back для страницы записи на интервью.
         * @summary Публичные данные вакансии по ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionPublicById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionPublicById', 'id', id)
            const localVarPath = `/public/positions/by-id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Доступно без авторизации. Поиск по UUID publicSlug (защита от перебора по id).
         * @summary Публичные данные вакансии по slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionPublicBySlug: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getPositionPublicBySlug', 'slug', slug)
            const localVarPath = `/public/positions/by-slug/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получает настройки интервью и все вопросы вакансии. Возвращает полную информацию для проведения собеседования. 
         * @summary Получить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionQuestionsAndSettings: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionQuestionsAndSettings', 'id', id)
            const localVarPath = `/positions/{id}/questions-and-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает агрегированную статистику по озвучке вопросов позиции
         * @summary Получить статус озвучки всех вопросов позиции
         * @param {number} id ID позиции
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionQuestionsVoiceStatus: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPositionQuestionsVoiceStatus', 'id', id)
            const localVarPath = `/positions/{id}/questions/voice/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Публичные данные вакансии по HH vacancy ID
         * @param {string} hhVacancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionSkillsByHhVacancyId: async (hhVacancyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hhVacancyId' is not null or undefined
            assertParamExists('getPositionSkillsByHhVacancyId', 'hhVacancyId', hhVacancyId)
            const localVarPath = `/public/positions/by-hh-vacancy/{hhVacancyId}`
                .replace(`{${"hhVacancyId"}}`, encodeURIComponent(String(hhVacancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список вакансий своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список вакансий
         * @param {PositionStatusEnum} [status] Фильтр по статусу вакансии
         * @param {string} [search] Поиск по названию, компании или описанию
         * @param {string} [owner] Фильтр по владельцу (me/all)
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions: async (status?: PositionStatusEnum, search?: string, owner?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (owner !== undefined) {
                localVarQueryParameter['owner'] = owner;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Асинхронно озвучивает все вопросы позиции. Возвращает taskId для отслеживания прогресса.
         * @summary Озвучить все вопросы позиции
         * @param {number} id ID позиции
         * @param {BulkVoiceSynthesisRequest} [bulkVoiceSynthesisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synthesizeAllPositionQuestions: async (id: number, bulkVoiceSynthesisRequest?: BulkVoiceSynthesisRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('synthesizeAllPositionQuestions', 'id', id)
            const localVarPath = `/positions/{id}/questions/voice/bulk`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkVoiceSynthesisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить вакансию
         * @param {number} id ID вакансии
         * @param {PositionUpdateRequest} positionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition: async (id: number, positionUpdateRequest: PositionUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePosition', 'id', id)
            // verify required parameter 'positionUpdateRequest' is not null or undefined
            assertParamExists('updatePosition', 'positionUpdateRequest', positionUpdateRequest)
            const localVarPath = `/positions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {AiScreeningToggleRequest} aiScreeningToggleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionAiScreeningFlag: async (id: number, aiScreeningToggleRequest: AiScreeningToggleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePositionAiScreeningFlag', 'id', id)
            // verify required parameter 'aiScreeningToggleRequest' is not null or undefined
            assertParamExists('updatePositionAiScreeningFlag', 'aiScreeningToggleRequest', aiScreeningToggleRequest)
            const localVarPath = `/positions/{id}/ai-screening`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiScreeningToggleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Обновить вопросы о компании для вакансии
         * @param {number} id 
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionCompanyQuestions: async (id: number, companyQuestionsRequest: CompanyQuestionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePositionCompanyQuestions', 'id', id)
            // verify required parameter 'companyQuestionsRequest' is not null or undefined
            assertParamExists('updatePositionCompanyQuestions', 'companyQuestionsRequest', companyQuestionsRequest)
            const localVarPath = `/positions/{id}/company-questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyQuestionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Полностью обновляет настройки интервью и все вопросы вакансии. Поддерживает как ручное обновление, так и автоматическую генерацию через ИИ с передачей ВСЕХ полей вакансии для создания профессиональных, разных и всеохватывающих вопросов. 
         * @summary Обновить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {PositionQuestionsAndSettingsUpdateRequest} positionQuestionsAndSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionQuestionsAndSettings: async (id: number, positionQuestionsAndSettingsUpdateRequest: PositionQuestionsAndSettingsUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePositionQuestionsAndSettings', 'id', id)
            // verify required parameter 'positionQuestionsAndSettingsUpdateRequest' is not null or undefined
            assertParamExists('updatePositionQuestionsAndSettings', 'positionQuestionsAndSettingsUpdateRequest', positionQuestionsAndSettingsUpdateRequest)
            const localVarPath = `/positions/{id}/questions-and-settings`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(positionQuestionsAndSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionsApi - functional programming interface
 * @export
 */
export const PositionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Назначает исполнителя (менеджера) для вакансии или снимает назначение. - Если указан managerId - назначает указанного пользователя менеджером - Если managerId не указан или равен null - снимает текущего менеджера Исполнитель должен быть из той же команды, что и вакансия. 
         * @summary Назначить или снять исполнителя (менеджера) вакансии
         * @param {number} id ID вакансии
         * @param {number | null} [managerId] ID пользователя-исполнителя (null или не указан для снятия назначения)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPositionManager(id: number, managerId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPositionManager(id, managerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.assignPositionManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Изменяет статус вакансии с дополнительной логикой и валидацией. Поддерживает переходы между статусами ACTIVE, PAUSED, ARCHIVED. При архивировании автоматически завершает все активные интервью. 
         * @summary Изменить статус вакансии
         * @param {number} id ID вакансии
         * @param {PositionStatusEnum} status Новый статус вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePositionStatus(id: number, status: PositionStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePositionStatus(id, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.changePositionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создать вакансию в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать вакансию
         * @param {PositionCreateRequest} positionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPosition(positionCreateRequest: PositionCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPosition(positionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.createPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Удалить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить вакансию
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePosition(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.deletePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить вакансию своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить вакансию по ID
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosition(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionAiScreeningFlag(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiScreeningToggleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionAiScreeningFlag(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionAiScreeningFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить вопросы о компании для вакансии
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionCompanyQuestions(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionCompanyQuestions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionCompanyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает только поля, необходимые для построения диалога рекрутера: skillGroups, description, officeCityId, officeLocations. Без данных брендинга (logoUrl, primaryColor, secondaryColor). Используется ai-recruiter-back (service-to-service). 
         * @summary Данные позиции для диалога (без брендинга)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionDialogueData(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionDialogueData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionDialogueData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Доступно без авторизации (service-to-service). Используется ai-recruiter-back для страницы записи на интервью.
         * @summary Публичные данные вакансии по ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionPublicById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionPublicById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionPublicById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Доступно без авторизации. Поиск по UUID publicSlug (защита от перебора по id).
         * @summary Публичные данные вакансии по slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionPublicBySlug(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionPublicBySlug(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionPublicBySlug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получает настройки интервью и все вопросы вакансии. Возвращает полную информацию для проведения собеседования. 
         * @summary Получить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionQuestionsAndSettings(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionQuestionsAndSettings(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionQuestionsAndSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает агрегированную статистику по озвучке вопросов позиции
         * @summary Получить статус озвучки всех вопросов позиции
         * @param {number} id ID позиции
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionQuestionsVoiceStatus(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionVoiceStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionQuestionsVoiceStatus(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionQuestionsVoiceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Публичные данные вакансии по HH vacancy ID
         * @param {string} hhVacancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPositionSkillsByHhVacancyId(hhVacancyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionSkillsByHhVacancyId(hhVacancyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.getPositionSkillsByHhVacancyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список вакансий своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список вакансий
         * @param {PositionStatusEnum} [status] Фильтр по статусу вакансии
         * @param {string} [search] Поиск по названию, компании или описанию
         * @param {string} [owner] Фильтр по владельцу (me/all)
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPositions(status?: PositionStatusEnum, search?: string, owner?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPositions(status, search, owner, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.listPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Асинхронно озвучивает все вопросы позиции. Возвращает taskId для отслеживания прогресса.
         * @summary Озвучить все вопросы позиции
         * @param {number} id ID позиции
         * @param {BulkVoiceSynthesisRequest} [bulkVoiceSynthesisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async synthesizeAllPositionQuestions(id: number, bulkVoiceSynthesisRequest?: BulkVoiceSynthesisRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkVoiceSynthesisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.synthesizeAllPositionQuestions(id, bulkVoiceSynthesisRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.synthesizeAllPositionQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить вакансию
         * @param {number} id ID вакансии
         * @param {PositionUpdateRequest} positionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePosition(id: number, positionUpdateRequest: PositionUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Position>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePosition(id, positionUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.updatePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {AiScreeningToggleRequest} aiScreeningToggleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePositionAiScreeningFlag(id: number, aiScreeningToggleRequest: AiScreeningToggleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePositionAiScreeningFlag(id, aiScreeningToggleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.updatePositionAiScreeningFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Обновить вопросы о компании для вакансии
         * @param {number} id 
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePositionCompanyQuestions(id: number, companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePositionCompanyQuestions(id, companyQuestionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.updatePositionCompanyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Полностью обновляет настройки интервью и все вопросы вакансии. Поддерживает как ручное обновление, так и автоматическую генерацию через ИИ с передачей ВСЕХ полей вакансии для создания профессиональных, разных и всеохватывающих вопросов. 
         * @summary Обновить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {PositionQuestionsAndSettingsUpdateRequest} positionQuestionsAndSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePositionQuestionsAndSettings(id: number, positionQuestionsAndSettingsUpdateRequest: PositionQuestionsAndSettingsUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePositionQuestionsAndSettings(id, positionQuestionsAndSettingsUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PositionsApi.updatePositionQuestionsAndSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PositionsApi - factory interface
 * @export
 */
export const PositionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionsApiFp(configuration)
    return {
        /**
         * Назначает исполнителя (менеджера) для вакансии или снимает назначение. - Если указан managerId - назначает указанного пользователя менеджером - Если managerId не указан или равен null - снимает текущего менеджера Исполнитель должен быть из той же команды, что и вакансия. 
         * @summary Назначить или снять исполнителя (менеджера) вакансии
         * @param {number} id ID вакансии
         * @param {number | null} [managerId] ID пользователя-исполнителя (null или не указан для снятия назначения)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPositionManager(id: number, managerId?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.assignPositionManager(id, managerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Изменяет статус вакансии с дополнительной логикой и валидацией. Поддерживает переходы между статусами ACTIVE, PAUSED, ARCHIVED. При архивировании автоматически завершает все активные интервью. 
         * @summary Изменить статус вакансии
         * @param {number} id ID вакансии
         * @param {PositionStatusEnum} status Новый статус вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePositionStatus(id: number, status: PositionStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.changePositionStatus(id, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Создать вакансию в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать вакансию
         * @param {PositionCreateRequest} positionCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPosition(positionCreateRequest: PositionCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.createPosition(positionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Удалить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить вакансию
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить вакансию своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить вакансию по ID
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosition(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.getPosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionAiScreeningFlag(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AiScreeningToggleResponse> {
            return localVarFp.getPositionAiScreeningFlag(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить вопросы о компании для вакансии
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionCompanyQuestions(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CompanyQuestions> {
            return localVarFp.getPositionCompanyQuestions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает только поля, необходимые для построения диалога рекрутера: skillGroups, description, officeCityId, officeLocations. Без данных брендинга (logoUrl, primaryColor, secondaryColor). Используется ai-recruiter-back (service-to-service). 
         * @summary Данные позиции для диалога (без брендинга)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionDialogueData(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PositionSkillsResponse> {
            return localVarFp.getPositionDialogueData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Доступно без авторизации (service-to-service). Используется ai-recruiter-back для страницы записи на интервью.
         * @summary Публичные данные вакансии по ID
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionPublicById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PositionPublicResponse> {
            return localVarFp.getPositionPublicById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Доступно без авторизации. Поиск по UUID publicSlug (защита от перебора по id).
         * @summary Публичные данные вакансии по slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionPublicBySlug(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PositionPublicResponse> {
            return localVarFp.getPositionPublicBySlug(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Получает настройки интервью и все вопросы вакансии. Возвращает полную информацию для проведения собеседования. 
         * @summary Получить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionQuestionsAndSettings(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PositionQuestionsResponse> {
            return localVarFp.getPositionQuestionsAndSettings(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает агрегированную статистику по озвучке вопросов позиции
         * @summary Получить статус озвучки всех вопросов позиции
         * @param {number} id ID позиции
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionQuestionsVoiceStatus(id: number, options?: RawAxiosRequestConfig): AxiosPromise<PositionVoiceStatusResponse> {
            return localVarFp.getPositionQuestionsVoiceStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Публичные данные вакансии по HH vacancy ID
         * @param {string} hhVacancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPositionSkillsByHhVacancyId(hhVacancyId: string, options?: RawAxiosRequestConfig): AxiosPromise<PositionSkillsResponse> {
            return localVarFp.getPositionSkillsByHhVacancyId(hhVacancyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список вакансий своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список вакансий
         * @param {PositionStatusEnum} [status] Фильтр по статусу вакансии
         * @param {string} [search] Поиск по названию, компании или описанию
         * @param {string} [owner] Фильтр по владельцу (me/all)
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPositions(status?: PositionStatusEnum, search?: string, owner?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponse> {
            return localVarFp.listPositions(status, search, owner, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Асинхронно озвучивает все вопросы позиции. Возвращает taskId для отслеживания прогресса.
         * @summary Озвучить все вопросы позиции
         * @param {number} id ID позиции
         * @param {BulkVoiceSynthesisRequest} [bulkVoiceSynthesisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synthesizeAllPositionQuestions(id: number, bulkVoiceSynthesisRequest?: BulkVoiceSynthesisRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkVoiceSynthesisResponse> {
            return localVarFp.synthesizeAllPositionQuestions(id, bulkVoiceSynthesisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить вакансию
         * @param {number} id ID вакансии
         * @param {PositionUpdateRequest} positionUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePosition(id: number, positionUpdateRequest: PositionUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Position> {
            return localVarFp.updatePosition(id, positionUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить флаг AI-скрининга для вакансии
         * @param {number} id ID вакансии
         * @param {AiScreeningToggleRequest} aiScreeningToggleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionAiScreeningFlag(id: number, aiScreeningToggleRequest: AiScreeningToggleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePositionAiScreeningFlag(id, aiScreeningToggleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Обновить вопросы о компании для вакансии
         * @param {number} id 
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionCompanyQuestions(id: number, companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyQuestions> {
            return localVarFp.updatePositionCompanyQuestions(id, companyQuestionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Полностью обновляет настройки интервью и все вопросы вакансии. Поддерживает как ручное обновление, так и автоматическую генерацию через ИИ с передачей ВСЕХ полей вакансии для создания профессиональных, разных и всеохватывающих вопросов. 
         * @summary Обновить настройки и вопросы вакансии
         * @param {number} id ID вакансии
         * @param {PositionQuestionsAndSettingsUpdateRequest} positionQuestionsAndSettingsUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePositionQuestionsAndSettings(id: number, positionQuestionsAndSettingsUpdateRequest: PositionQuestionsAndSettingsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PositionQuestionsResponse> {
            return localVarFp.updatePositionQuestionsAndSettings(id, positionQuestionsAndSettingsUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PositionsApi - object-oriented interface
 * @export
 * @class PositionsApi
 * @extends {BaseAPI}
 */
export class PositionsApi extends BaseAPI {
    /**
     * Назначает исполнителя (менеджера) для вакансии или снимает назначение. - Если указан managerId - назначает указанного пользователя менеджером - Если managerId не указан или равен null - снимает текущего менеджера Исполнитель должен быть из той же команды, что и вакансия. 
     * @summary Назначить или снять исполнителя (менеджера) вакансии
     * @param {number} id ID вакансии
     * @param {number | null} [managerId] ID пользователя-исполнителя (null или не указан для снятия назначения)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public assignPositionManager(id: number, managerId?: number | null, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).assignPositionManager(id, managerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Изменяет статус вакансии с дополнительной логикой и валидацией. Поддерживает переходы между статусами ACTIVE, PAUSED, ARCHIVED. При архивировании автоматически завершает все активные интервью. 
     * @summary Изменить статус вакансии
     * @param {number} id ID вакансии
     * @param {PositionStatusEnum} status Новый статус вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public changePositionStatus(id: number, status: PositionStatusEnum, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).changePositionStatus(id, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создать вакансию в своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Создать вакансию
     * @param {PositionCreateRequest} positionCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public createPosition(positionCreateRequest: PositionCreateRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).createPosition(positionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удалить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Удалить вакансию
     * @param {number} id ID вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public deletePosition(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).deletePosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить вакансию своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить вакансию по ID
     * @param {number} id ID вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPosition(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить флаг AI-скрининга для вакансии
     * @param {number} id ID вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionAiScreeningFlag(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionAiScreeningFlag(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить вопросы о компании для вакансии
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionCompanyQuestions(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionCompanyQuestions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает только поля, необходимые для построения диалога рекрутера: skillGroups, description, officeCityId, officeLocations. Без данных брендинга (logoUrl, primaryColor, secondaryColor). Используется ai-recruiter-back (service-to-service). 
     * @summary Данные позиции для диалога (без брендинга)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionDialogueData(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionDialogueData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Доступно без авторизации (service-to-service). Используется ai-recruiter-back для страницы записи на интервью.
     * @summary Публичные данные вакансии по ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionPublicById(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionPublicById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Доступно без авторизации. Поиск по UUID publicSlug (защита от перебора по id).
     * @summary Публичные данные вакансии по slug
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionPublicBySlug(slug: string, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionPublicBySlug(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получает настройки интервью и все вопросы вакансии. Возвращает полную информацию для проведения собеседования. 
     * @summary Получить настройки и вопросы вакансии
     * @param {number} id ID вакансии
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionQuestionsAndSettings(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionQuestionsAndSettings(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает агрегированную статистику по озвучке вопросов позиции
     * @summary Получить статус озвучки всех вопросов позиции
     * @param {number} id ID позиции
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionQuestionsVoiceStatus(id: number, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionQuestionsVoiceStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Публичные данные вакансии по HH vacancy ID
     * @param {string} hhVacancyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public getPositionSkillsByHhVacancyId(hhVacancyId: string, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).getPositionSkillsByHhVacancyId(hhVacancyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список вакансий своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить список вакансий
     * @param {PositionStatusEnum} [status] Фильтр по статусу вакансии
     * @param {string} [search] Поиск по названию, компании или описанию
     * @param {string} [owner] Фильтр по владельцу (me/all)
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Поле для сортировки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public listPositions(status?: PositionStatusEnum, search?: string, owner?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).listPositions(status, search, owner, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Асинхронно озвучивает все вопросы позиции. Возвращает taskId для отслеживания прогресса.
     * @summary Озвучить все вопросы позиции
     * @param {number} id ID позиции
     * @param {BulkVoiceSynthesisRequest} [bulkVoiceSynthesisRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public synthesizeAllPositionQuestions(id: number, bulkVoiceSynthesisRequest?: BulkVoiceSynthesisRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).synthesizeAllPositionQuestions(id, bulkVoiceSynthesisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновить вакансию своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Обновить вакансию
     * @param {number} id ID вакансии
     * @param {PositionUpdateRequest} positionUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public updatePosition(id: number, positionUpdateRequest: PositionUpdateRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).updatePosition(id, positionUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить флаг AI-скрининга для вакансии
     * @param {number} id ID вакансии
     * @param {AiScreeningToggleRequest} aiScreeningToggleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public updatePositionAiScreeningFlag(id: number, aiScreeningToggleRequest: AiScreeningToggleRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).updatePositionAiScreeningFlag(id, aiScreeningToggleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Обновить вопросы о компании для вакансии
     * @param {number} id 
     * @param {CompanyQuestionsRequest} companyQuestionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public updatePositionCompanyQuestions(id: number, companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).updatePositionCompanyQuestions(id, companyQuestionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Полностью обновляет настройки интервью и все вопросы вакансии. Поддерживает как ручное обновление, так и автоматическую генерацию через ИИ с передачей ВСЕХ полей вакансии для создания профессиональных, разных и всеохватывающих вопросов. 
     * @summary Обновить настройки и вопросы вакансии
     * @param {number} id ID вакансии
     * @param {PositionQuestionsAndSettingsUpdateRequest} positionQuestionsAndSettingsUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionsApi
     */
    public updatePositionQuestionsAndSettings(id: number, positionQuestionsAndSettingsUpdateRequest: PositionQuestionsAndSettingsUpdateRequest, options?: RawAxiosRequestConfig) {
        return PositionsApiFp(this.configuration).updatePositionQuestionsAndSettings(id, positionQuestionsAndSettingsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



